import React, { useState, useEffect } from "react";
import { supabase } from "../../supabaseClient";
import AdminChampionship from "./AdminChampionship";
import AdminVeteraniChampionship from "./AdminVeteraniChampionship";

const AdminChampionshipContainer = ({ selectedTurnirId }) => {
  const [activeTab, setActiveTab] = useState("seniori");
  const [hasVeterani, setHasVeterani] = useState(false);

  useEffect(() => {
    if (!selectedTurnirId) return;

    supabase
      .from("admin_turniri")
      .select("features")
      .eq("id", selectedTurnirId)
      .single()
      .then(({ data, error }) => {
        if (data) {
          setHasVeterani(data.features?.veterani === true);
        } else if (error) {
          console.error("Greška kod dohvata features postavki:", error);
        }
      });
  }, [selectedTurnirId]);

  return (
    <div className="admin-championship-container-wrapper">
      {hasVeterani && (
        <div className="category-switcher-bar">
          <button
            className={`switcher-btn ${activeTab === "seniori" ? "active" : ""}`}
            onClick={() => setActiveTab("seniori")}
          >
            Seniori
          </button>
          <button
            className={`switcher-btn ${activeTab === "veterani" ? "active" : ""}`}
            onClick={() => setActiveTab("veterani")}
          >
            Veterani
          </button>
        </div>
      )}

      <div className="category-content">
        {activeTab === "seniori" || !hasVeterani ? (
          <AdminChampionship selectedTurnirId={selectedTurnirId} />
        ) : (
          <AdminVeteraniChampionship selectedTurnirId={selectedTurnirId} />
        )}
      </div>
    </div>
  );
};

export default AdminChampionshipContainer;
